export default (colors) => {
  if (!colors || !colors.length) {
    return [];
  }

  // Ignore dead indexes
  return colors.filter((color) => color && typeof color === 'string');
};
